import useSyncData from '~/hooks/data/useSyncData';
import { HighscoresAPI } from './HighscoresAPI';

export const useHighscores = (clientID: string, gameID: string, limit: number = -1) => {
    const subscribe = HighscoresAPI.subscribe(clientID, gameID);
    const getSnapshot = () => HighscoresAPI.getSnapshot(clientID, gameID, limit);

    const highscores = useSyncData(subscribe, getSnapshot, [clientID, gameID]);
    return highscores !== undefined ? highscores : [];
};

export const useDailyHighscores = (clientID: string, gameID: string, limit: number = -1) => {
    const subscribe = HighscoresAPI.subscribe(clientID, gameID);
    const getSnapshot = () => HighscoresAPI.getDailySnapshot(clientID, gameID, limit);

    const highscores = useSyncData(subscribe, getSnapshot, [clientID, gameID]);
    return highscores !== undefined ? highscores : [];
};
